import { render, staticRenderFns } from "./PublicatorRow.vue?vue&type=template&id=320ca2d4&scoped=true"
import script from "./PublicatorRow.vue?vue&type=script&lang=js"
export * from "./PublicatorRow.vue?vue&type=script&lang=js"
import style0 from "./PublicatorRow.vue?vue&type=style&index=0&id=320ca2d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320ca2d4",
  null
  
)

export default component.exports